/* global bootstrap */
'use strict';

import './form-contact';

/* Fancybox */
import {Fancybox} from "@fancyapps/ui/dist/fancybox/fancybox.umd.js";

require('!style-loader!css!@fancyapps/ui/dist/fancybox/fancybox.css');
//import autosize from 'autosize';
/* Slick Carousel */
// import 'slick-carousel';
// require('!style-loader!css!slick-carousel/slick/slick.css');
/* jQuery Match Height */
//import 'jquery-match-height';

// Force CSS update
// https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/30#issuecomment-256958209
// Update 15/07/2022, inspiré de https://github.com/webpack-contrib/extract-text-webpack-plugin/issues/30#issuecomment-294845326
// Update 28/10/2022 : en fait, il faut supprimer le fichier CSS de base vu que la nouvelle CSS est injectée via le Hot module
if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
        const reporter = window.__webpack_hot_middleware_reporter__
        const success = reporter.success
        reporter.success = function () {
            document.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
                if (link.href.match(/\/dist\/styles\/main.css/) || link.href.match(/\/dist\/styles\/main_[^.]+.css/)) {
                    link.parentNode.removeChild(link);
                }
            });
            success()
        }
    }
}

(function ($) {

    function is_touch_device() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }

    function smoothScroll(hash) {
        hash = hash.replace(/#goto-(.+)/, '#$1');
        if ($(hash).length || hash === '#top') {
            var offset_top = (hash === '#top') ? 0 : $(hash).offset().top;
            if ($('.fixed-top').length) {
                offset_top = offset_top - $('.fixed-top').outerHeight();
            }
            if ($('#wpadminbar').length) {
                offset_top = offset_top - $('#wpadminbar').outerHeight();
            }
            $('html, body').animate({
                scrollTop: offset_top
            }, 0);
        }
    }

    function popupCenter(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = typeof (window.screenLeft) !== "undefined" ? window.screenLeft : screen.left;
        var dualScreenTop = typeof (window.screenTop) !== "undefined" ? window.screenTop : screen.top;

        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }
    }

    $(window)
        .on('load', function () {
            $('body').removeClass('firstload');
        })
        .on('load resize statechangecomplete', function () {
            if (is_touch_device()) {
                $('body').addClass('touch-device');
            } else {
                $('body').removeClass('touch-device');
            }
        })
        .on('load statechangecomplete', function () {

            // Enable tooltips everywhere
            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl, {html: true});
            });

            // Enable popovers everywhere
            const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
            popoverTriggerList.map(function (popoverTriggerEl) {
                return new bootstrap.Popover(popoverTriggerEl, {html: true, trigger: 'focus'});
            });

            if (window.location.hash) {
                setTimeout(function () {
                    smoothScroll(window.location.hash);
                }, 100);
            }

            if (typeof Fancybox !== 'undefined') { // pcq parfois ça bug en mode "watch"
                Fancybox.defaults.Hash = false;
                Fancybox.defaults.Thumbs = false;
                Fancybox.bind("[data-fancybox]:not(.slick-cloned)");
            }
        });

    $('body')
        .on('click', '.action-social-share', function (e) {
            e.preventDefault();
            popupCenter($(this).attr('href'), '', 650, 360);
        })
        .on('click', 'a[href^="#"]', function (event) {
            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "" && $(this).data('toggle') != 'tab') {
                // Prevent default anchor click behavior
                event.preventDefault();
                smoothScroll(this.hash);
            } // End if
        })
        .on('mouseenter mouseleave', '.dropdown-hover', function (e) {
            if ($(window).width() >= 992) {
                var _d = $(this).find('.dropdown-menu').eq(0);
                _d[(e.type === "mouseenter") ? 'addClass' : 'removeClass']('show');
            }
        })
        .on('change', 'select.form-control, .custom-select', function () {
            if ($(this).val() !== "") {
                $(this).removeClass('place_holder');
            } else {
                $(this).addClass('place_holder');
            }
        })
        .on('click', '.navbar-toggler', function() {
            $(this).toggleClass('open');
        })
        .on('click', '#openTools', function() {
            document.querySelector('.section-canif .content').classList.toggle('open');
            document.querySelector('.section-canif .btn').classList.toggle('open');
        });

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/main.js